import { useLanguage } from '../context/LanguageContext'
const NAVY = '#002E53'
const GOLD = '#C5A059'
const FONT = "'Poppins', sans-serif"

const BENEFIT_KEYS = ['b1', 'b2', 'b3', 'b4', 'b5', 'b6']
const BENEFIT_ICONS = ['🏠', '👨‍👩‍👧‍👦', '✈️', '🔄', '🌍', '📈']
const STEP_KEYS = ['s1', 's2', 's3', 's4']


function GoldenVisaSection() {
  const { t } = useLanguage()
  const BENEFITS = BENEFIT_KEYS.map((k, i) => ({
    icon: BENEFIT_ICONS[i],
    title: t(`goldenVisa.benefits.${k}t`),
    desc: t(`goldenVisa.benefits.${k}d`),
  }))
  const STEPS = STEP_KEYS.map((k, i) => ({ num: String(i+1).padStart(2,'0'), label: t(`goldenVisa.steps.${k}`) }))
  return (
    <div style={{ width: '100%', background: '#fff' }}>
      <style>{`
        .gv-card {
          background: #f8fafc;
          border-radius: 14px;
          padding: 28px 24px;
          border: 1px solid rgba(0,46,83,0.07);
          transition: all 0.3s ease;
          cursor: default;
        }
        .gv-card:hover {
          background: #fff;
          border-color: ${GOLD}55;
          box-shadow: 0 8px 32px rgba(197,160,89,0.12);
          transform: translateY(-4px);
        }
        .gv-step-num {
          font-family: 'Georgia', serif;
          font-size: 42px;
          font-weight: 700;
          color: ${GOLD}30;
          line-height: 1;
          margin-bottom: 6px;
        }
        @media (max-width: 768px) {
          .gv-grid { grid-template-columns: 1fr !important; }
          .gv-card-grid { grid-template-columns: 1fr 1fr !important; }
          .gv-steps { grid-template-columns: 1fr 1fr !important; }
          .gv-hero-inner { flex-direction: column !important; gap: 30px !important; }
        }
        @media (max-width: 480px) {
          .gv-card-grid { grid-template-columns: 1fr !important; }
          .gv-steps { grid-template-columns: 1fr !important; }
        }
      `}</style>

      {/* ─── Hero Banner ─────────────────────────── */}
      <div style={{
        background: `linear-gradient(135deg, ${NAVY} 0%, #001525 100%)`,
        width: '100%',
        padding: '70px 20px',
        position: 'relative',
        overflow: 'hidden',
      }}>
        {/* Background decorative elements */}
        <div style={{ position: 'absolute', top: '-100px', right: '-100px', width: '450px', height: '450px', borderRadius: '50%', background: `${GOLD}08`, pointerEvents: 'none' }} />
        <div style={{ position: 'absolute', bottom: '-80px', left: '-60px', width: '320px', height: '320px', borderRadius: '50%', background: `${GOLD}06`, pointerEvents: 'none' }} />
        {/* UAE flag stripe accent */}
        <div style={{ position: 'absolute', top: 0, left: 0, width: '6px', height: '100%', background: `linear-gradient(to bottom, #00732F 33%, #fff 33%, #fff 66%, #FF0000 66%)`, opacity: 0.5 }} />

        <div style={{ maxWidth: '1100px', margin: '0 auto', position: 'relative', zIndex: 1 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '60px', flexWrap: 'wrap' }} className="gv-hero-inner">

            {/* Left — copy */}
            <div style={{ flex: '1 1 440px' }}>
              <span style={{
                display: 'inline-flex', alignItems: 'center', gap: '8px',
                background: `${GOLD}22`, color: GOLD,
                fontFamily: FONT, fontSize: '11px', fontWeight: 700, letterSpacing: '1.8px',
                padding: '6px 16px', borderRadius: '50px', textTransform: 'uppercase',
                border: `1px solid ${GOLD}40`, marginBottom: '18px',
              }}>
                { t('goldenVisa.badge') }
              </span>
              <h2 style={{
                fontFamily: FONT, fontSize: 'clamp(28px, 4vw, 48px)', fontWeight: 700,
                color: '#fff', margin: '0 0 12px', lineHeight: 1.15, letterSpacing: '-0.5px',
              }}>
                { t('goldenVisa.heading') }<br />
                <span style={{ color: GOLD }}>{ t('goldenVisa.headingGold') }</span>
              </h2>
              <p style={{
                fontFamily: FONT, fontSize: '16px', color: 'rgba(255,255,255,0.65)',
                margin: '0 0 28px', lineHeight: 1.7, maxWidth: '480px',
              }}>
                { t('goldenVisa.desc') }
              </p>
              <a
                href="/contact"
                style={{
                  display: 'inline-flex', alignItems: 'center', gap: '8px',
                  background: GOLD, color: '#fff',
                  fontFamily: FONT, fontSize: '15px', fontWeight: 600,
                  padding: '14px 30px', borderRadius: '10px',
                  textDecoration: 'none', transition: 'background 0.2s, transform 0.15s',
                }}
                onMouseEnter={e => { e.currentTarget.style.background = '#d4af6a'; e.currentTarget.style.transform = 'translateY(-2px)' }}
                onMouseLeave={e => { e.currentTarget.style.background = GOLD; e.currentTarget.style.transform = 'translateY(0)' }}
              >
                { t('goldenVisa.cta') }
              </a>
            </div>

            {/* Right — key stat card */}
            <div style={{ flex: '0 0 auto' }}>
              <div style={{
                background: 'rgba(255,255,255,0.06)',
                border: `1px solid ${GOLD}30`,
                borderRadius: '18px',
                padding: '36px 40px',
                textAlign: 'center',
                backdropFilter: 'blur(12px)',
                minWidth: '240px',
              }}>
                <div style={{ fontFamily: "'Georgia', serif", fontSize: '64px', fontWeight: 700, color: GOLD, lineHeight: 1 }}>10</div>
                <div style={{ fontFamily: FONT, fontSize: '14px', color: 'rgba(255,255,255,0.7)', marginTop: '4px', letterSpacing: '1px', textTransform: 'uppercase' }}>{ t('goldenVisa.yearVisa') }</div>
                <div style={{ borderTop: '1px solid rgba(255,255,255,0.1)', margin: '20px 0' }} />
                <div style={{ fontFamily: FONT, fontSize: '13px', color: 'rgba(255,255,255,0.5)', lineHeight: 1.5 }}>
                  { t('goldenVisa.minValue') }<br />
                  <strong style={{ fontSize: '18px', color: '#fff', fontWeight: 600 }}>AED 2,000,000</strong>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ─── Benefits Grid ─────────────────────── */}
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '64px 20px 0', boxSizing: 'border-box' }}>
        <div style={{ textAlign: 'center', marginBottom: '44px' }}>
          <h3 style={{ fontFamily: FONT, fontSize: 'clamp(22px, 2.5vw, 32px)', fontWeight: 700, color: NAVY, margin: 0 }}>
            { t('goldenVisa.benefitsHeading') }
          </h3>
          <p style={{ fontFamily: FONT, fontSize: '15px', color: '#6b7a8d', marginTop: '10px', maxWidth: '520px', marginLeft: 'auto', marginRight: 'auto', lineHeight: 1.6 }}>
            { t('goldenVisa.benefitsSubheading') }
          </p>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '20px' }} className="gv-card-grid">
          {BENEFITS.map((b, i) => (
            <div key={i} className="gv-card">
              <div style={{ fontSize: '30px', marginBottom: '14px' }}>{b.icon}</div>
              <div style={{ fontFamily: FONT, fontSize: '16px', fontWeight: 700, color: NAVY, marginBottom: '8px' }}>{b.title}</div>
              <div style={{ fontFamily: FONT, fontSize: '14px', color: '#5a6577', lineHeight: 1.65 }}>{b.desc}</div>
            </div>
          ))}
        </div>
      </div>

      {/* ─── How It Works ──────────────────────── */}
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '56px 20px 0px', boxSizing: 'border-box' }}>
        <div style={{ textAlign: 'center', marginBottom: '40px' }}>
          <h3 style={{ fontFamily: FONT, fontSize: 'clamp(20px, 2.5vw, 28px)', fontWeight: 700, color: NAVY, margin: '0 0 8px' }}>
            { t('goldenVisa.stepsHeading') }
          </h3>
          <p style={{ fontFamily: FONT, fontSize: '14px', color: '#8a9ab0', margin: 0 }}>{ t('goldenVisa.stepsSubheading') }</p>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '20px' }} className="gv-steps">
          {STEPS.map((s, i) => (
            <div key={i} style={{ textAlign: 'center', padding: '28px 20px', position: 'relative' }}>
              {/* Connector line */}
              {i < STEPS.length - 1 && (
                <div style={{ position: 'absolute', top: '48px', right: '-10px', width: '20px', height: '2px', background: `${GOLD}40` }} />
              )}
              <div className="gv-step-num">{s.num}</div>
              <div style={{
                width: '48px', height: '48px', borderRadius: '50%',
                background: `${GOLD}18`, border: `2px solid ${GOLD}`,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                margin: '0 auto 16px',
                fontFamily: FONT, fontSize: '18px', fontWeight: 700, color: GOLD,
              }}>
                {i + 1}
              </div>
              <p style={{ fontFamily: FONT, fontSize: '14px', color: '#4a5568', lineHeight: 1.6, margin: 0 }}>{s.label}</p>
            </div>
          ))}
        </div>

        {/* CTA strip */}
        <div style={{
          background: `${GOLD}10`, border: `1px solid ${GOLD}35`,
          borderRadius: '14px', padding: '24px 32px',
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          flexWrap: 'wrap', gap: '16px', marginTop: '20px',
        }}>
          <div>
            <div style={{ fontFamily: FONT, fontSize: '16px', fontWeight: 700, color: NAVY }}>{ t('goldenVisa.stepCtaHeading') }</div>
            <div style={{ fontFamily: FONT, fontSize: '14px', color: '#6b7a8d', marginTop: '4px' }}>{ t('goldenVisa.stepCtaDesc') }</div>
          </div>
          <a href="/contact" style={{
            display: 'inline-block', background: NAVY, color: '#fff',
            fontFamily: FONT, fontSize: '14px', fontWeight: 600,
            padding: '12px 26px', borderRadius: '8px', textDecoration: 'none',
            whiteSpace: 'nowrap', transition: 'background 0.2s',
          }}
            onMouseEnter={e => e.currentTarget.style.background = '#001a33'}
            onMouseLeave={e => e.currentTarget.style.background = NAVY}
          >
            { t('goldenVisa.stepCtaBtn') }
          </a>
        </div>
      </div>
    </div>
  )
}

export default GoldenVisaSection
